import React from "react";
import NewCollaborators from "./NewCollaborators";
import CollaboratorBoard from "./CollaboratorBoard";
import { CustomCard, Title } from "../../Utils/UI/Text";

const Collaborators = () => {
  return (
    <>
      <Title children={"Colaboradores"} childrenTwo={<NewCollaborators />} />
      <CustomCard>
        <CollaboratorBoard />
      </CustomCard>
    </>
  );
};

export default Collaborators;
